export enum CatalogEvents {
  fetchCatalog = 'fetchCatalog',
  fetchSettingCatalog = 'fetchSettingCatalog',
}
